type UserRolesType = {
    unregistered: 'Unregistered',
    allRegistered: 'AllRegistered', 
    admin: 'Admin', 
    groupLeader: 'Leader',
    groupMember: 'Member',
    disabledMember: 'Disabled',
}
export const UserRoles: UserRolesType = {
    unregistered: 'Unregistered',
    allRegistered: 'AllRegistered', 
    admin: 'Admin', 
    groupLeader: 'Leader',
    groupMember: 'Member',
    disabledMember: 'Disabled',
}

export type UserRolesValues = typeof UserRoles[keyof typeof UserRoles]

export const AllUserRoles: UserRolesValues[] = Array.from(Object.values(UserRoles));

export const UserRolesNames:{ [key in UserRolesValues]: string } = {
    [UserRoles.unregistered]: 'Unregistered User',
    [UserRoles.allRegistered]: 'Registered User',
    [UserRoles.admin]: 'Admin',
    [UserRoles.groupLeader]: 'Leader',
    [UserRoles.groupMember]: 'Member',
    [UserRoles.disabledMember]: 'Non-Member',
}

export default UserRoles;